module.exports = __webpack_public_path__ + "static/media/about-us.546c8b0a.PNG";